import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { persistReducer, createTransform } from 'redux-persist';
import reduxPersistStorage from 'redux-persist/lib/storage';
import initReducer from '../init/reducer';
import authReducer from '../auth/reducer';
import userReducer from '../user/reducer';
import viewActionReducer from '../actions/reducer';
import analyticsPhotoReducer from '../analytics/photos/reducer';
import analyticsReducer from '../analytics/reducer';
import viewChallengeReducer from '../challenges/reducer';
import challengesReducer from '../screens/ChallengesScreen/reducer';
import notificationsReducer from '../notifications/reducer';
import communityReducer from '../community/reducer';
import imageReducer from '../image/reducer';
import flagsReducer from '../flags/reducer';
import updateChalllengeReducer from '../screens/UpdateChallengeScreen/reducer';
import themesReducer from '../communityThemes/reducer';
import settingsReducer from '../screens/SettingsScreen/reducer';
import deepLinksReducer from '../deepLinks/reducer';
import inviteUsersReducer from '../store/inviteUsers/reducer';
import activitiesReducer from '../activities/reducer';
import subscriptionReducer from '../subscriptions/reducer';
import shortLinksReducer from '../shortLinks/reducer';

const authPersistConfig = {
    key: 'auth',
    storage: reduxPersistStorage,
    whitelist: ['token', 'onBoarding', 'sso'],
};

const subscriptionPersistConfig = {
    key: 'subscription',
    storage: reduxPersistStorage,
    whitelist: ['stripePlanId'],
};

// Persist challenge creation so that refreshing the /get-started/invite page doesn't break it
const viewChallengePersistConfig = {
    key: 'viewChallenge',
    storage: reduxPersistStorage,
    whitelist: ['creation'],
};

const userTransform = createTransform(
    (inboundState) => {
        if (!inboundState) {
            return {}; // return if empty so we don't try to read from it
        }
        // exclude communityMemberships and communityPermissions from the persisted state so localStorage doesn't exceed quota
        const {
            communityMemberships,
            communityPermissions,
            ...rest
        } = inboundState;
        // console.log('Persisting user state:', rest);
        return rest; // persist the state w/o the excluded fields
    },
    (outboundState) => outboundState, // no transform on rehydration
    { whitelist: ['user'] },
);

const userPersistConfig = {
    key: 'user',
    storage: reduxPersistStorage,
    transforms: [userTransform],
    whitelist: [
        'user',
        'dismissedInfoCardIds',
        'userViewActive',
        'activeCommunity',
    ],
};

export default function createRootReducer(history) {
    return combineReducers({
        router: connectRouter(history),
        init: initReducer,
        deepLinks: deepLinksReducer,
        auth: persistReducer(authPersistConfig, authReducer),
        user: persistReducer(userPersistConfig, userReducer),
        viewChallenge: persistReducer(
            viewChallengePersistConfig,
            viewChallengeReducer,
        ),
        viewAction: viewActionReducer,
        analyticsPhoto: analyticsPhotoReducer,
        analytics: analyticsReducer,
        activities: activitiesReducer,
        challenges: challengesReducer,
        flags: flagsReducer,
        notifications: notificationsReducer,
        community: communityReducer,
        themes: themesReducer,
        image: imageReducer,
        updateChallenge: updateChalllengeReducer,
        settings: settingsReducer,
        inviteUsers: inviteUsersReducer,
        subscription: persistReducer(
            subscriptionPersistConfig,
            subscriptionReducer,
        ),
        shortLinks: shortLinksReducer
    });
}
